export enum NotificationCenterConstants {
  FETCH_NOTIFICATIONS = 'notificationCenter/FETCH_NOTIFICATIONS',
  SET_NOTIFICATIONS = 'notificationCenter/SET_NOTIFICATIONS',
  REMOVE_NOTIFICATION = 'notificationCenter/REMOVE_NOTIFICATION',
  SET_OPENED_FLAG_ID = 'notificationCenter/SET_OPENED_FLAG_ID',
  SET_READ_FLAG_IDS = 'notificationCenter/SET_READ_FLAG_IDS',
  MARK_NOTIFICATION_READ = 'notificationCenter/MARK_NOTIFICATION_READ',
  SET_NOTIFICATIONS_LOADING = 'notificationCenter/SET_NOTIFICATIONS_LOADING',
  RESET_STATE = 'notificationCenter/RESET_STATE',
  START_NOTIFICATION_POLLING = 'notificationCenter/START_NOTIFICATION_POLLING',
  STOP_NOTIFICATION_POLLING = 'notificationCenter/STOP_NOTIFICATION_POLLING',
  MARK_NOTIFICATIONS_VIEWED = 'notificationCenter/MARK_NOTIFICATIONS_VIEWED',
  SET_POLLED_NOTIFICATION_IDS = 'notificationCenter/SET_POLLED_NOTIFICATION_IDS',
  SET_VIEWED_NOTIFICATION_IDS = 'notificationCenter/SET_VIEWED_NOTIFICATION_IDS',
  NOTIFICATION_POLLING_INTERVAL_IN_MINS = 'NOTIFICATION_POLLING_INTERVAL_IN_MINS',
  NOTIFICATION_RETRY_COUNT = 'NOTIFICATION_RETRY_COUNT',
}
